export interface DateRangeOption {
  value: string;
  label: string;
  /** How far back the range reaches. `null` is "no lower bound at all". */
  days: number | null;
}

/*
 * The presets a list page gets when it does not name its own — the same five
 * the Vue console offered everywhere it asked this question.
 */
export const DEFAULT_DATE_RANGE_OPTIONS: readonly DateRangeOption[] = [
  { value: '1d', label: 'Last 24 hours', days: 1 },
  { value: '7d', label: 'Last 7 days', days: 7 },
  { value: '30d', label: 'Last 30 days', days: 30 },
  { value: '90d', label: 'Last 90 days', days: 90 },
  { value: 'all', label: 'All time', days: null },
];
